import { useTranslation } from "react-i18next";

import { ItemBadge } from "../../services/menu/models";
import { badgeTitle, fillToCss } from "./libs";
import styles from "./style.module.sass";

interface IProps {
    badges: ItemBadge[];
}

/*
* Плашки бейджей позиции. Оформление целиком приходит с бэка, поэтому цвета — инлайн-стилем:
* заведение задаёт их в кабинете, и в SASS их не выразить (так же сделано с цветом кнопок меню).
* */
export const ItemBadges = ({ badges }: IProps) => {
    const { i18n } = useTranslation();

    if (badges.length === 0) return null;

    return (
        <div className={styles.row}>
            {badges.map((badge) => (
                <p
                    key={badge.id}
                    className={styles.badge}
                    style={{ background: fillToCss(badge.fill), color: badge.textColor }}
                >
                    {badgeTitle(badge.title, i18n.language)}
                </p>
            ))}
        </div>
    );
};

export default ItemBadges;
